import {
  Flex,
  IconButton,
  IconEditLine,
  IconTrashLine,
  Text,
} from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { ProgramTypeService } from "../../services/ProgramTypeService";
import { Card } from "../Card";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import { DialogYesNo } from "../DialogYesNo";
import ProgramTypesModal from "./ProgramTypesModal";

const ProgramTypeCard = ({ programType, setProgramTypes }) => {
  const showNotification = useNotification();
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDelete = async () => {
    try {
      await ProgramTypeService.deleteProgramType(programType.id);
      setProgramTypes((prev) =>
        prev.filter((type) => type.id !== programType.id)
      );
      showNotification(
        t("notifications.general.deleteSuccess", { obj: "Program Type" })
      );
    } catch {
      showNotification(
        t("notifications.general.deleteError", { obj: "Program Type" }),
        ERROR
      );
    }
  };

  return (
    <Card
      style={{
        color: "#0D323F",
        backgroundColor: "#F2F8FA",
        border: "1px solid #ccc",
        borderRadius: 10,
        padding: "10px 15px",
        marginBottom: 15,
      }}
    >
      <Flex>
        <Flex.Item shouldGrow shouldShrink>
          <Text weight="bold">{programType.name}</Text>
        </Flex.Item>
        <Flex.Item margin="0 small 0 0">
          <EditProgramTypeButton
            programType={programType}
            setProgramTypes={setProgramTypes}
          />
        </Flex.Item>
        <Flex.Item>
          <IconButton
            renderIcon={IconTrashLine}
            screenReaderLabel={t("programType.deleteProgramType")}
            size="small"
            onClick={() => setDeleteModal(true)}
          />
        </Flex.Item>
      </Flex>
      <DialogYesNo
        message={t("programType.deleteConfirm")}
        openStatus={deleteModal}
        onClickNo={() => setDeleteModal(false)}
        onClickYes={handleDelete}
      />
    </Card>
  );
};

const EditProgramTypeButton = ({ programType, setProgramTypes }) => {
  const showNotification = useNotification();
  const [open, setOpen] = useState(false);

  const handleEditProgramType = async (typeName) => {
    const newProgramType = { ...programType, name: typeName };
    try {
      await ProgramTypeService.updateProgramType(newProgramType);
      setProgramTypes((prev) =>
        prev.map((type) =>
          type.id === programType.id ? { ...type, name: typeName } : type
        )
      );
      setOpen(false);
      showNotification(
        t("notifications.general.updateSuccess", { obj: "Program Type" })
      );
    } catch {
      showNotification(
        t("notifications.general.updateError", { obj: "Program Type" }),
        ERROR
      );
    }
  };

  return (
    <>
      <IconButton
        renderIcon={IconEditLine}
        screenReaderLabel={t("programType.editProgramType")}
        size="small"
        onClick={() => setOpen(true)}
      />
      <ProgramTypesModal
        open={open}
        setOpen={setOpen}
        programType={programType}
        handleSubmit={handleEditProgramType}
      />
    </>
  );
};

export default ProgramTypeCard;
